import { render, staticRenderFns } from "./orderingPlatform.vue?vue&type=template&id=ec0d33d2&scoped=true&"
import script from "./orderingPlatform.vue?vue&type=script&lang=js&"
export * from "./orderingPlatform.vue?vue&type=script&lang=js&"
import style0 from "./orderingPlatform.vue?vue&type=style&index=0&id=ec0d33d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec0d33d2",
  null
  
)

export default component.exports